import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PermissionConditionForm } from '@newroom-connect/library/interfaces';
import { PermissionConditionService } from '@newroom-connect/library/services';

import { IconComponent } from '../icon/icon.component';
import { PermissionConditionBuilderComponent } from '../permission-condition-builder/permission-condition-builder.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IconComponent,
    PermissionConditionBuilderComponent
  ],
  selector: 'nrc-condition-builder',
  templateUrl: './condition-builder.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConditionBuilderComponent {
  @Input() public collectionName = '';
  public conditions = new FormArray<FormGroup<PermissionConditionForm>>([]);

  constructor(private permissionConditionService: PermissionConditionService) {}

  /**
   * Adds a new condition to the form array.
   */
  public addCondition(): void {
    const condition = this.permissionConditionService.createConditionForm();

    this.conditions.push(condition);
  }

  /**
   * Removes a condition from the form array.
   * @param condition The condition to remove.
   */
  public removeCondition(condition: FormGroup<PermissionConditionForm>): void {
    const index = this.conditions.controls.indexOf(condition);

    if (index > -1) {
      this.conditions.removeAt(index);
    }
  }
}
